

import { abonoGastosApi } from "../../apis";
import Swal from "sweetalert2";




export const abonosXGastos = async(id) => {
    try {
        const { data } = await abonoGastosApi.get(`/porfactura/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const crearAbonoGasto = async(datos) => {
    try {
        
        const { data } = await abonoGastosApi.post(`/new`, datos);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




// export const eliminarAbonoOp = async(id) => {
//     try {
//         await abonosApi.delete(`/${id}`);
//         Swal.fire('Exitoso', 'Abono e imagen eliminados', 'success');
//         return true;
//     } catch (error) {
//         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
//         Swal.fire('Error', errores, 'error');
//         return false;
//     }
// }